import type { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-label="signin"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#F55036"
      d="M9.067 0C5.234 0 1.74 2.232.097 5.719a1.014 1.014 0 0 0 .472 1.337.993.993 0 0 0 1.329-.476 7.93 7.93 0 0 1 7.17-4.563c4.391 0 7.93 3.562 7.93 7.984 0 4.423-3.539 7.993-7.93 7.993a7.933 7.933 0 0 1-7.17-4.566.994.994 0 0 0-1.84.096c-.089.25-.075.527.038.767A9.927 9.927 0 0 0 9.067 20C14.541 20 19 15.512 19 10.001 19 4.491 14.54 0 9.067 0Zm1.057 5.748a.996.996 0 0 0-.703.305 1.01 1.01 0 0 0 .023 1.426l1.565 1.519H4.134a.996.996 0 0 0-.708.292 1.01 1.01 0 0 0-.003 1.427c.189.19.445.296.711.295h6.879L9.444 12.53a1.01 1.01 0 0 0-.023 1.426.997.997 0 0 0 1.41.024l3.36-3.25a1.011 1.011 0 0 0 0-1.45l-3.36-3.255a.995.995 0 0 0-.707-.276Z"
    />
  </svg>
);
export default SvgComponent;
